import { Col, PageHeader } from 'antd';
import {
  MainContainer,
  LeftCol,
} from 'app/components/LayoutComponents/LayoutComponents';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import UsedResourceDetails from '../../parts/UsedResourceDetails/UsedResourceDetails';
import UsedResourcesByTypeCard from '../../parts/UsedResourcesByTypeCard/UsedResourcesByTypeCard';

interface IProps {}

const UsedResourcesPage: FC<IProps> = () => {
  const { t } = useTranslation();

  const [selectedUsedResourceId, setSelectedUsedResourceId] = useState<
    number | undefined
  >();

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Resource.UsedResource.Title', 'Used resources')}
      />
      <MainContainer>
        <LeftCol $width={350}>
          <UsedResourcesByTypeCard
            setSelectedUsedResourceId={setSelectedUsedResourceId}
            selectedUsedResourceId={selectedUsedResourceId}
          />
        </LeftCol>
        <Col flex={1}>
          {selectedUsedResourceId && (
            <UsedResourceDetails usedResourceId={selectedUsedResourceId} />
          )}
        </Col>
      </MainContainer>
    </>
  );
};

export default UsedResourcesPage;
